export class keyValueModal{
    key:string;
    value:string;
}